import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { CheckSquare, Copy } from "lucide-react";
import { toast } from "sonner";

export default function TickTick() {
  const [brief, setBrief] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    if (!brief.trim()) return;
    setBusy(true); setRes(null);
    try {
      const r = await api.post("/api/ticktick/export", { brief });
      setRes(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  const copy = () => { navigator.clipboard.writeText(res.text); toast.success("Paste into TickTick"); };

  return (
    <AppLayout title="TickTick export" overline="110 · PASTE-READY TASK LIST">
      <div className="grid lg:grid-cols-2 gap-6">
        <section className="border border-zinc-900 bg-zinc-950 p-6 fade-up">
          <div className="overline mb-3">Brief / things you want to do</div>
          <textarea value={brief} onChange={(e) => setBrief(e.target.value)} rows={12}
            placeholder="Film 2 TikToks this week about gym motivation, edit Mykonos trip vlog by Sunday, reply to 5 PPV prospects, schedule IG post for Friday..."
            data-testid="ticktick-input"
            className="w-full bg-black border border-zinc-900 text-white p-3 text-sm focus:outline-none focus:border-[color:var(--gio-primary)]" />

          <button onClick={generate} disabled={busy || !brief.trim()} data-testid="ticktick-generate-button"
            className="btn-primary mt-4 w-full flex items-center justify-center gap-2 disabled:opacity-40">
            <CheckSquare size={16} /> {busy ? "Organizing..." : "Generate task list"}
          </button>
        </section>

        <section className="border border-zinc-900 bg-zinc-950 p-6 fade-up" data-testid="ticktick-output">
          <div className="flex items-center justify-between mb-3">
            <div className="overline text-[color:var(--gio-primary)]">OUTPUT · PASTE INTO TICKTICK</div>
            {res?.text && (
              <button onClick={copy} data-testid="ticktick-copy-button" className="text-zinc-500 hover:text-[color:var(--gio-primary)] text-xs font-mono-ui flex items-center gap-1">
                <Copy size={14} /> COPY ALL
              </button>
            )}
          </div>
          {!res && !busy && <div className="text-zinc-600 text-sm">Your task list will appear here — copy and paste into TickTick.</div>}
          {busy && <div className="overline text-[color:var(--gio-primary)]">ORGANIZING...</div>}
          {res?.text && (
            <pre className="text-white text-sm whitespace-pre-wrap font-mono-ui leading-relaxed">{res.text}</pre>
          )}
        </section>
      </div>
    </AppLayout>
  );
}
